export default "__VITE_ASSET__75ef4c64__"